export const validation = {
  reply: "Please enter a reply",
};
